/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import {Modal, Button} from 'react-bootstrap';
import PrintIcon from '@material-ui/icons/Print';
import GetAppIcon from '@material-ui/icons/GetApp';
import ShareIcon from '@material-ui/icons/Share';
import parse from 'html-react-parser';
// import Pdf from 'react-to-pdf'; -- react-to-pdf": "0.0.14"
import {
  FacebookShareCount,
  RedditShareCount,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  RedditShareButton,
  EmailShareButton,
  LivejournalShareButton,
  WorkplaceShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  RedditIcon,
  EmailIcon,
  LivejournalIcon,
  WorkplaceIcon,
} from 'react-share';
import '../css/HomeContent.css';

/**
 * @component Renders the share menu
 * @param {*} props props
 * @return {Component} ShareMenu component
 */
function ShareMenu(props) {
  const shareUrl = 'http://github.com';
  const title = 'GitHub';

  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Share</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <div className="share-container">
            <EmailShareButton
              url={shareUrl}
              subject={title}
              body="body"
              className="share-button"
            >
              <EmailIcon size={64} round />
            </EmailShareButton>
          </div>

          <div className="share-container">
            <FacebookShareButton
              url={shareUrl}
              quote={title}
              className="share-button"
            >
              <FacebookIcon size={64} round />
            </FacebookShareButton>

            <div>
              <FacebookShareCount url={shareUrl} className="share-count">
                {(count) => count}
              </FacebookShareCount>
            </div>
          </div>

          <div className="share-container">
            <LinkedinShareButton url={shareUrl} className="share-button">
              <LinkedinIcon size={64} round />
            </LinkedinShareButton>
          </div>

          <div className="share-container">
            <RedditShareButton
              url={shareUrl}
              title={title}
              windowWidth={660}
              windowHeight={460}
              className="share-button"
            >
              <RedditIcon size={64} round />
            </RedditShareButton>

            <div>
              <RedditShareCount
                url={shareUrl}
                className="Demo__some-network__share-count"
              />
            </div>
          </div>

          <div className="share-container">
            <LivejournalShareButton
              url={shareUrl}
              title={title}
              description={shareUrl}
              className="share-button"
            >
              <LivejournalIcon size={64} round />
            </LivejournalShareButton>
          </div>

          <div className="share-container">
            <TwitterShareButton
              url={shareUrl}
              title={title}
              className="share-button"
            >
              <TwitterIcon size={64} round />
            </TwitterShareButton>

            <div className="share-count">&nbsp;</div>
          </div>

          <div className="share-container">
            <WorkplaceShareButton
              url={shareUrl}
              quote={title}
              className="share-button"
            >
              <WorkplaceIcon size={64} round />
            </WorkplaceShareButton>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

const GoTop = (props) => {
  const [intervalId, setIntervalId] = React.useState(0);
  const [thePosition, setThePosition] = React.useState(false);

  const timeoutRef = React.useRef(null);

  React.useEffect(() => {
    document.addEventListener('scroll', () => {
      if (window.scrollY > 170) {
        setThePosition(true);
      } else {
        setThePosition(false);
      }
    });
    // window.scrollTo(0, 0);
  }, []);

  const onScrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(timeoutRef.current);
    }
    window.scroll(0, window.pageYOffset - props.scrollStepInPx);
  };

  const scrollToTop = () => {
    timeoutRef.current = setInterval(onScrollStep, props.delayInMs);
  };

  const renderGoTopIcon = () => {
    return (
      <button
        className={`go-top ${thePosition ? 'active' : ''}`}
        style={{color: '#21606A', fontSize: '25px', padding: '0', border: 'none', backgroundColor: 'none', background: 'none'}}
        onClick={scrollToTop}
      >
        Back To Top
      </button>
    );
  };

  return <React.Fragment>{renderGoTopIcon()}</React.Fragment>;
};


const HomeContentPropTypes = {
  post: PropTypes.any,
  category: PropTypes.any,
};


/**
 * @component The component rendering a grid for home content
 * @param {*} props post
 * @return {Component} HomeConent component
 */
function HomeContent(props) {
  const post = props.post;
  const category = props.category;

  const [shareMenuShow, setModalShow] = React.useState(false);

  const ref = React.createRef();

  function PrintArticle() {
    window.print(
      <Card className="homecontent-text">
        <div>
          {post}
        </div>
      </Card>
    );
  }

  return (
    <>
      <div className="homecontent-banner" />
      <div className="homecontent-container">
        <div className="homecontent-banner-gap" />
        <h2 className="homecontent-header-text">{category}</h2>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            margin: '20px auto',
          }}
        >
          <button
            className="homecontent-icon-wrapper"
            onClick={() => PrintArticle()}
          >
            <PrintIcon style={{fontSize: '30px'}} />
          </button>
          {/* <Pdf
            targetRef={ref}
            filename="ais-article.pdf"
            y={0.5}
            scale={0.7}
            style={{border: '2px solid red'}}
          >
            {({toPdf}) => (
              <button className="homecontent-icon-wrapper" onClick={toPdf}>
                <GetAppIcon style={{fontSize: '30px'}} />
              </button>
            )}
          </Pdf> */}
          <button
            className="homecontent-icon-wrapper"
            onClick={() => setModalShow(true)}
          >
            <ShareIcon style={{fontSize: '30px'}} />
          </button>
        </div>
        <ShareMenu show={shareMenuShow} onHide={() => setModalShow(false)} />
        <div className="homecontent-md-container" ref={ref}>
          <Card className="homecontent-text">
            {parse(post)}
            {/* <img src={image} style={{display: 'block', margin: '60px auto', width: '60%', }}/> */}
          </Card>
          <br />
          <br />
        </div>
        <GoTop scrollStepInPx="100" delayInMs="10.50" />
      </div>
    </>
  );
}

HomeContent.propTypes = HomeContentPropTypes;

export default HomeContent;